import CSS from 'csstype';
import { SyntheticEvent, useState } from "react";
import { Container, Hero, Image, Navbar } from "react-bulma-components";
import { useAuthContext } from "../features/auth/AuthProvider";
import { LoggedInUserButton } from "../features/auth/LoggedInUserButton";
import { homeRoute, useRouteContext } from "../features/route/RouteProvider";
import { SignInWithGoogleButton } from "../features/auth/SignInWithGoogleButton";
import { SignOutButton } from "../features/auth/SignOutButton";
import logo from "../logo.png";
import { NewFeaturesButton } from "./NewFeaturesButton";

const menuStyles: CSS.Properties = { color: 'white' };

type RetroHeroHeaderProps = { crumb?: { label: string; href: string; onClick: () => void } }

export const RetroHeroHeader = ({ crumb }: RetroHeroHeaderProps = {}) => {
  const [uid, loading] = useAuthContext();
  const [, setRoute] = useRouteContext();
  const [isMenuActive, setIsMenuActive] = useState(false);

  const onClickToggleMenu = () => setIsMenuActive(!isMenuActive);

  return (
    <Hero.Header>
      <Navbar>
        <Container>
          <Navbar.Brand className={!uid ? "is-stretched" : undefined}>
            <Navbar.Item href="/" onClick={(e: SyntheticEvent) => { e.preventDefault(); setRoute(homeRoute); }}>
              <Image src={logo} />
            </Navbar.Item>
            {crumb && (
              <Navbar.Item href={crumb.href} onClick={(e: SyntheticEvent) => { e.preventDefault(); crumb.onClick(); }}>
                <span className="has-text-white">{crumb.label}</span>
              </Navbar.Item>
            )}
            {!uid && (
              <Navbar.Item style={{ marginLeft: "auto" }}>
                <SignInWithGoogleButton initializing={loading} />
              </Navbar.Item>
            )}
            {uid && (
              <Navbar.Burger style={menuStyles} onClick={onClickToggleMenu} className={isMenuActive ? "is-active" : ""}>
                <span aria-hidden="true" />
                <span aria-hidden="true" />
                <span aria-hidden="true" />
              </Navbar.Burger>
            )}
          </Navbar.Brand>
          {uid && (
            <Navbar.Menu className={isMenuActive ? "is-active" : ""}>
              <Navbar.Container align="right">
                <Navbar.Item>
                  <LoggedInUserButton uid={uid} />
                  <NewFeaturesButton />
                </Navbar.Item>
                <Navbar.Item>
                  <SignOutButton />
                </Navbar.Item>
              </Navbar.Container>
            </Navbar.Menu>
          )}
        </Container>
      </Navbar>
    </Hero.Header>
  )
}
